import { api } from './services'

export const getMyLiveDeals = () => api.get('/company/liveDeals')
export const getDealById = (dealId) => api.get(`/deals/${dealId}`)
